(() => {
  const root = document.querySelector('[data-calabrese-booking]');
  if (!root) return;

const bookingVideoSlot = root.querySelector('.calabrese-booking__video-slot');
const bookingProductsColumn = root.querySelector('.calabrese-booking__products-column');
const bookingProductsStep = root.querySelector('.calabrese-booking__step--products');
const bookingSummary = root.querySelector('.calabrese-booking__summary');
const bookingMobileQuery = window.matchMedia('(max-width: 749px)');

const placeBookingVideo = () => {
  if (!bookingVideoSlot || !bookingProductsColumn || !bookingProductsStep || !bookingSummary) return;
  if (bookingMobileQuery.matches) {
    if (bookingVideoSlot.parentElement !== bookingSummary) {
      bookingSummary.insertBefore(bookingVideoSlot, bookingSummary.querySelector('h2'));
    }
  } else if (bookingVideoSlot.parentElement !== bookingProductsColumn) {
    bookingProductsColumn.insertBefore(bookingVideoSlot, bookingProductsStep);
  }
};

placeBookingVideo();
if (bookingMobileQuery.addEventListener) {
  bookingMobileQuery.addEventListener('change', placeBookingVideo);
} else if (bookingMobileQuery.addListener) {
  bookingMobileQuery.addListener(placeBookingVideo);
}

const bookingVideo = root.querySelector('.calabrese-booking__video-slot video');
if (bookingVideo) {
  let controlsTimer;
  const revealControls = () => {
    bookingVideo.controls = true;
    window.clearTimeout(controlsTimer);
    controlsTimer = window.setTimeout(() => { bookingVideo.controls = false; }, 3000);
  };
  bookingVideo.addEventListener('pointerdown', revealControls);
  bookingVideo.addEventListener('click', revealControls);
  bookingVideo.addEventListener('ended', () => {
    window.clearTimeout(controlsTimer);
    bookingVideo.controls = false;
  });
}

  const copy = window.calabreseBookingStrings || {};
  const toggles = [...root.querySelectorAll('[data-category-toggle]')];
  const requestedCategory = new URLSearchParams(window.location.search).get('booking_category');
  if (requestedCategory) {
    const requestedToggle = toggles.find((input) => input.value === requestedCategory);
    if (requestedToggle) requestedToggle.checked = true;
  }
  const groups = [...root.querySelectorAll('[data-category]')];
  const empty = root.querySelector('[data-booking-empty]');
  const categoryCount = root.querySelector('[data-category-count]');
  const cartCount = root.querySelector('[data-booking-cart-count]');
  const cartLines = root.querySelector('[data-booking-cart-lines]');
  const subtotal = root.querySelector('[data-booking-subtotal]');
  const checkout = root.querySelector('[data-booking-checkout]');
  const baseUrl = copy.rootUrl || '/';

  const formatMoney = (amount) => new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
    style: 'currency',
    currency: copy.currency || 'EUR',
  }).format(amount / 100);

  const refreshCategories = () => {
    const selected = new Set(toggles.filter((input) => input.checked).map((input) => input.value));
    groups.forEach((group) => { group.hidden = !selected.has(group.dataset.category); });
    if (empty) empty.hidden = selected.size > 0;
    if (categoryCount) categoryCount.textContent = selected.size;
  };

  const refreshCart = async () => {
    try {
      const response = await fetch(`${baseUrl}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (cartCount) cartCount.textContent = cart.item_count;
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      if (checkout) checkout.href = `${baseUrl}${cart.item_count ? 'checkout' : 'cart'}`;
      if (!cartLines) return;
      cartLines.replaceChildren();
      if (!cart.items.length) {
        const note = document.createElement('p');
        note.textContent = copy.emptyCart || 'Il carrello è vuoto.';
        cartLines.append(note);
        return;
      }
      cart.items.slice(0, 4).forEach((item) => {
        const row = document.createElement('div');
        row.className = 'calabrese-booking__cart-line';
        const name = document.createElement('span');
        name.textContent = `${item.product_title} × ${item.quantity}`;
        const price = document.createElement('strong');
        price.textContent = formatMoney(item.final_line_price);
        row.append(name, price);
        cartLines.append(row);
      });
      if (cart.items.length > 4) {
        const more = document.createElement('p');
        more.className = 'calabrese-booking__more-items';
        more.textContent = `+ ${cart.items.length - 4} ${copy.items || 'altri articoli'}`;
        cartLines.append(more);
      }
    } catch (error) {
      if (cartLines) cartLines.textContent = '';
    }
  };

  const scrollToSelectedProducts = (categoryHandle) => {
    if (!bookingMobileQuery.matches || !bookingProductsStep) return;
    const selectedGroup = groups.find((group) => group.dataset.category === categoryHandle && !group.hidden);
    const target = selectedGroup || bookingProductsStep;
    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  toggles.forEach((input) => input.addEventListener('change', () => {
    refreshCategories();
    if (input.checked) scrollToSelectedProducts(input.value);
  }));

  root.querySelectorAll('[data-booking-product-form]').forEach((form) => {
    form.querySelector('select[name="id"]')?.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const price = form.querySelector('[data-variant-price]');
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('.calabrese-booking__status');
      const original = button.innerHTML;
      button.disabled = true;
      button.querySelector('span:last-child').textContent = copy.adding || 'Aggiunta…';
      try {
        const response = await fetch(`${baseUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin',
        });
        if (!response.ok) throw new Error('cart');
        await response.json();
        if (status) status.textContent = copy.added || 'Prodotto aggiunto al carrello.';
        button.querySelector('span:first-child').textContent = '✓';
        button.querySelector('span:last-child').textContent = copy.addedShort || 'Aggiunto';
        await refreshCart();
        window.setTimeout(() => { button.innerHTML = original; }, 1400);
      } catch (error) {
        if (status) status.textContent = copy.error || 'Non siamo riusciti ad aggiungerlo. Riprova.';
        button.innerHTML = original;
      } finally {
        button.disabled = false;
      }
    });
  });

  refreshCategories();
  refreshCart();
})();
